import React from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Tooltip, makeStyles } from "@material-ui/core";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";

import { useTranslation } from "../../i18n";
import { getAlarmMessage } from "../../domain/alarm";

const useStyles = makeStyles(theme => ({
  alert: {
    padding: theme.spacing(0.25, 1),
    marginBottom: theme.spacing(0.5),
    "& .MuiAlert-icon": {
      padding: 0,
      marginRight: theme.spacing(1),
      alignItems: "center"
    },
    "& .MuiAlert-message": {
      padding: theme.spacing(0.25, 0)
    }
  },
  title: {
    margin: 0,
    fontSize: "0.75rem",
    fontWeight: "bold"
  }
}));

// Same presentation as Device/Status's Alarm.js (icon + tooltip + title), minus the
// confirm/disregard action, which doesn't belong in a quick map preview.
const AlarmMessages = ({ alarms }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {alarms.map(alarm => {
        const { title, description } = getAlarmMessage(alarm, t);
        const descriptionNode = (
          <span style={{ lineHeight: 1.5, fontSize: 12 }}>{description}</span>
        );

        return (
          <Alert
            key={alarm.id}
            severity="error"
            variant="outlined"
            className={classes.alert}
            icon={
              <Tooltip title={descriptionNode} placement="top" arrow>
                <ReportProblemOutlinedIcon fontSize="small" />
              </Tooltip>
            }
          >
            <AlertTitle className={classes.title}>{title}</AlertTitle>
          </Alert>
        );
      })}
    </>
  );
};

export default AlarmMessages;
